import { styled } from "@mui/material/styles";
import { Link, Typography } from "@mui/material";

import ResponsiveImage from "components/ResponsiveImage";

export const Main = styled("div")(({ theme }) => ({
  backgroundImage: theme.palette.baseGradient,
  padding: "44px 10px 56px",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  [theme.breakpoints.up("tablet")]: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "50px 71px 50px 54px",
  },
}));

export const Logo = styled(ResponsiveImage)(({ theme }) => ({
  height: 90,
  marginBottom: 40,
  [theme.breakpoints.up("tablet")]: {
    marginBottom: 0,
    marginRight: 52,
  },
}));

export const Nav = styled("nav")(({ theme }) => ({
  width: "100%",
  maxWidth: 316,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: 52,
  [theme.breakpoints.up("mobile")]: {
    maxWidth: 352,
  },
  [theme.breakpoints.up("tablet")]: {
    marginBottom: 0,
    flex: 1,
  },
}));

export const NavLink = styled(Link)(({ theme }) => ({
  color: theme.palette.common.white,
  fontSize: theme.typography.small.fontSize,
}));

export const Social = styled("nav")(({ theme }) => ({
  width: "100%",
  maxWidth: 305,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  [theme.breakpoints.up("tablet")]: {
    marginLeft: "auto",
  },
}));

export const SocialLogo = styled(ResponsiveImage)({
  width: 32,
  height: 32,
});

export const Copyright = styled(Typography)(({ theme }) => ({
  padding: "34px 32px",
  [theme.breakpoints.up("mobile")]: {
    padding: "32px 140px",
  },
  [theme.breakpoints.up("tablet")]: {
    padding: "43px 168px",
  },
}));
